import { isProjectsInJiraM2Enabled } from '@jira/native-integration-projects/src/index.tsx';

export default {
	get(): boolean {
		return isProjectsInJiraM2Enabled();
	},
};
